import React from 'react'; 
import { Backdrop, CircularProgress } from '@material-ui/core';
import useLoadingStyles from './loading.styles';

interface LoadingProps {
    message?: string;
    color?: 'primary' | 'secondary' | 'inherit';
}

const Loading: React.FC<LoadingProps> = ({ message, color }) => {
    const classes = useLoadingStyles();

    return (
        <div className={classes.root}>
            <CircularProgress size={28} thickness={6} color={color} />
            <h3>{message}</h3>
        </div>
    )
}

export default Loading;

interface LoadingOnBackdropProps {
    status: boolean;
    message?: string;
}

export const LoadingOnBackdrop: React.FC<LoadingOnBackdropProps> = ({ status, message }) => {
    const classes = useLoadingStyles();

    return (
        <Backdrop open={status} className={classes.backdrop} >
          <Loading message={message} color='inherit' />
        </Backdrop>
    )
}